export default{popover:"w_Gs",nubbin:"w_Gt",bottomCenter:"w_Gu",bottomLeft:"w_Gv",bottomRight:"w_Gw",left:"w_Gx",right:"w_Gy",topCenter:"w_Gz",topLeft:"w_G0",topRight:"w_G1",content:"w_G2"};
